'use strict';


import { BaseElement } from '../../interfaces/BaseElement';
import { assignDeep, threeJsVariables, TRoot } from '../../../settings';
import { poiToggle } from '../../poi/poiCss';
import { Objects } from '../../threejs/Objects/Objects';
import { hideBuildingLabels, showBuildingLabels } from '../building-switch/buildingLabels';
import { Environment } from '../Environment/Environment';
import { PublicLayers } from '../publicLayers/PublicLayers';

const DEFAULT_CONFIG = {
	active: false
};

const PublicLayersIDs = ['poi','Parks','Education','Leisure','Fun','objectCssLabels','buildingLabels','parks','education','leisure','fun'];

export class CssLabelManager {
	constructor () {
		this.config = assignDeep({},DEFAULT_CONFIG,config.features.cssLabelManager || {});
		this.visible = true;
		this.block = false;
	}
	
	createButton(parent) {
		if (!this.active)
			return;
		
		this.container = new BaseElement()
			.addClass('css-label-manager','background-backdrop-filter')
			.addAttribute('data-active',this.visible)
			.event('click',this.#clickHandler.bind(this))
			.appendTo(parent)
			.DOMElement;
		
		new BaseElement()
			.addClass('css-label-manager__icon','icon-open')
			.appendTo(this.container)
			.DOMElement;
		
		new BaseElement()
			.addClass('css-label-manager__icon','icon-closed')
			.appendTo(this.container)
			.DOMElement;
	}
	
	hide() {
		hideBuildingLabels();
		Objects.visibilityCSSLabels(false);
		if (PublicLayers.isActive) {
			if (PublicLayers.activeLayer && PublicLayersIDs.includes(PublicLayers.activeLayer.type)) {
				PublicLayers.activeLayer.hide();
			}
		} else if (Environment.isActive()) {
			const activePublicLayer = Environment.getActivePublicLayer();
			if (activePublicLayer && PublicLayersIDs.includes(activePublicLayer.id)) {
				activePublicLayer.publicButtonHandler();
			}
		}
	}
	
	show() {
		showBuildingLabels();
		Objects.visibilityCSSLabels(true);
		if (PublicLayers.isActive) {
			if (PublicLayers.activeLayer && PublicLayersIDs.includes(PublicLayers.activeLayer.type)) {
				PublicLayers.activeLayer.show();
			}
		} else if (Environment.isActive()) {
			const activePublicLayer = Environment.getActivePublicLayer();
			if (activePublicLayer && PublicLayersIDs.includes(activePublicLayer.id)) {
				activePublicLayer.publicButtonHandler();
			}
		}
	}
	
	#clickHandler() {
		this.visible = !this.visible;
		if (this.visible) {
			this.block = false;
			this.show();
		} else {
			this.hide();
			this.block = true;
		}
		
		this.container.setAttribute('data-active',this.visible);
	}
	
	isBlocked(id) {
		if (!this.active)
			return false;
		
		return this.block && PublicLayersIDs.includes(id);
	}
	
	get active() {
		return this.config.active;
	}
}
